
import GraficosVendas from "@/components/GraficosVendas";

export default {
  name: "VendasPorDia",
  data: () => ({
    relatorio: [],
    colunas: [],
    data: null,
    headers: {
      dadosPorVendedor: [
        { text: "Vendedor", value: "vendedor" },
        { text: "Vendas", value: "quantidadeDeVendas" },
        { text: "Valor Total", value: "valorTotal" },
      ],
      analitica: [
        { text: "ID", value: "id" },
        { text: "Vendedor", value: "nome_vendedor" },
        { text: "Isento", value: "insento_adesao" },
        { text: "Pagamento", value: "forma_pagamento_adesao" },
        { text: "Valor", value: "valor_adesao" },
        { text: "Plano", value: "nome_plano" },
      ],
      dadosPorUnidade: [
        { text: "Unidade", value: "unidade" },
        { text: "Vendas", value: "quantidadeDeVendas" },
        { text: "Valor Total", value: "valorTotal" },
      ],
    },
  }),

  components: {
    GraficosVendas,
  },

  computed: {
    dataToString() {
      return this.data
        ? this.data.toLocaleDateString().replace(new RegExp("/", "g"), "-")
        : null;
    },
    listaDeVendedores() {
      let vendedores = this.relatorio.map((i) => i.nome_vendedor);
      return new Set([...vendedores]);
    },
    listaDeUnidades() {
      let unidades = this.relatorio.map((i) => i.nome_unidade);
      return new Set([...unidades]);
    },
    totalVendas() {
      return this.relatorio.length
        ? this.relatorio.map((i) => i.valor_adesao).reduce((a, c) => a + c)
        : null;
    },
    dadosPorVendedor() {
      let vendedores = Array.from(this.listaDeVendedores);
      return vendedores.map((vendedor) => {
        let quantidadeDeVendas = this.relatorio.filter(
          (i) => i.nome_vendedor == vendedor
        ).length;
        let valorTotal = this.relatorio
          .filter((i) => i.nome_vendedor == vendedor)
          .map((i) => i.valor_adesao)
          .reduce((a, c) => a + c);
        return {
          vendedor,
          quantidadeDeVendas,
          valorTotal,
        };
      });
    },
    dadosPorUnidade() {
      let unidades = Array.from(this.listaDeUnidades);
      return unidades.map((unidade) => {
        let quantidadeDeVendas = this.relatorio.filter(
          (i) => i.nome_unidade == unidade
        ).length;
        let valorTotal = this.relatorio
          .filter((i) => i.nome_unidade == unidade)
          .map((i) => i.valor_adesao)
          .reduce((a, c) => a + c);
        return {
          unidade,
          quantidadeDeVendas,
          valorTotal,
        };
      });
    },
  },
  methods: {
    getRelatorio() {
      let i = this.data.split("-");
      this.$http
        .get(`/relatorio/vendas/por-periodo/${i[2]}-${i[1]}-${i[0]}`)
        .then((response) => (this.relatorio = response.data))
        .catch(() => this.$toast.open("Ocorreu um erro ao buscar o relatório"));
    },
  },

  watch: {
    data() {
      this.getRelatorio();
    },
  },

  filters: {
    dinheiro(value) {
      let dinheiro = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return dinheiro.format(value);
    },
  },
};
